import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
//import { DashboardComponent } from './dashboard/dashboard.component';
import { ChangepasswordComponent } from './changepassword/changepassword.component';
import { RegisteruserasComponent } from './common/registeruseras/registeruseras.component';
import { MSMEUSERVERIFICATIONComponent } from './MSME/msmeuserverification/msmeuserverification.component';
import { RegisterComponent } from './MSME/register/register.component';
import { CredentialdetailsComponent } from './MSME/credentialdetails/credentialdetails.component';
import { ContactdetailsComponent } from './MSME/contactdetails/contactdetails.component';
import { PersonaldetailsComponent } from './MSME/personaldetails/personaldetails.component';
import { MsmepreviewpageComponent } from './MSME/msmepreviewpage/msmepreviewpage.component';
import { IAregisterComponent } from './IA/iaregister/iaregister.component';
import { ProfileComponent } from './MSME/profile/profile.component';
import { ForgotpasswordComponent } from './forgotpassword/forgotpassword.component';
import { IapreviewpageComponent } from './IA/iapreviewpage/iapreviewpage.component';
import { IaproposalpageComponent } from './IA/iaproposalpage/iaproposalpage.component';
import { IasubmitnewproposalComponent } from './IA/iasubmitnewproposal/iasubmitnewproposal.component';
import { MssidcproposalpageComponent } from './MSSIDC/mssidcproposalpage/mssidcproposalpage.component';
import { MssidcverifyproposalComponent } from './MSSIDC/mssidcverifyproposal/mssidcverifyproposal.component';
import { VerifymsmeComponent } from './MSSIDC/Verify-MSME/verifymsme.component';
import { VerifyMSMEDetailsComponent } from './MSSIDC/verify-msme-details/verify-msme-details.component';
import { VerifyMSMEViewComponent } from './MSSIDC/verify-msme-view/verify-msme-view.component';
import { IaprofileComponent } from './IA/iaprofile/iaprofile.component';
import { OtheruserdetailsComponent } from './MSME/otheruserdetails/otheruserdetails.component';
import { CreatenewproposalComponent } from './IA/createnewproposal/createnewproposal.component';
import { IaeventcreateComponent } from './IA/iaeventcreate/iaeventcreate.component';
import { LayoutComponent } from './layout/layout.component';
import { FundManagementComponent } from '../admin/master/fund-management/fund-management.component';
import { AuthService } from '../../../shared/services/auth.service';
import { ProposalComponent } from './IA/proposal/proposal.component';
import { EnrollneweventComponent } from './MSME/enrollnewevent/enrollnewevent.component';
import { VieweventsComponent } from './MSME/viewevents/viewevents.component';
import { IaquestionanswerComponent } from './IA/iaquestionanswer/iaquestionanswer.component';
import { FeedbackformComponent } from './MSME/feedbackform/feedbackform.component';
import { ViewgrievancesdashboardComponent } from './MSME/viewgrievancesdashboard/viewgrievancesdashboard.component';
import { ViewflattedgalaComponent } from './MSME/viewflattedgala/viewflattedgala.component';
import { VieweventdetailsComponent } from './MSME/vieweventdetails/vieweventdetails.component';
import { DownloadticketComponent } from './MSME/downloadticket/downloadticket.component';
import { DashboardComponent } from './MSME/dashboard/dashboard.component';
//import { CalenderComponent } from './calender/calender.component';
import { VerifyProposalComponent } from './MSSIDC/verify-proposal/verify-proposal.component';
import { VerifyProposalDetailsComponent } from './MSSIDC/verify-proposal-details/verify-proposal-details.component';
import { VieweventComponent } from './IA/viewevent/viewevent.component';
import { EventdetailComponent } from './MSSIDC/eventdetail/eventdetail.component';
import { WorkorderComponent } from './MSSIDC/workorder/workorder.component';
import { FullCalendarComponent } from '@fullcalendar/angular';
import { FullCalenderComponent } from '../full-calender/full-calender.component';
import { dicDashboardComponent } from './DIC/dashboard/dicdashboard.component';
import { IaeventcompletionComponent } from './IA/iaeventcompletion/iaeventcompletion.component';
import { IaeventmarkattendanceComponent } from './IA/iaeventmarkattendance/iaeventmarkattendance.component';
import { OnspotregistrationComponent } from './IA/onspotregistration/onspotregistration.component';
import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { ViewallonspotregistrationComponent } from './IA/viewallonspotregistration/viewallonspotregistration.component';
import { IadashboardComponent } from './IA/iadashboard/iadashboard.component';
import { SubmitgrievanceComponent } from './MSME/submitgrievance/submitgrievance.component';
import { EventreportComponent } from './IA/eventreport/eventreport.component';
import { GrievancedashboardComponent } from './MSME/grievancedashboard/grievancedashboard.component';
import { GrievancedashboardmssidcComponent } from './MSSIDC/grievancedashboardmssidc/grievancedashboardmssidc.component';
import { GrievancedashboardiaComponent } from './IA/grievancedashboardia/grievancedashboardia.component';
import { ViewandreplygrievanceComponent } from './MSSIDC/viewandreplygrievance/viewandreplygrievance.component';
import { MsmeotherdetailsComponent } from './MSSIDC/msmeotherdetails/msmeotherdetails.component';
import { ViewiadetailsComponent } from './MSSIDC/viewiadetails/viewiadetails.component';
import { ViewandreplygrievancebyiaComponent } from './IA/viewandreplygrievancebyia/viewandreplygrievancebyia.component';
import { ViewgrievancereplyComponent } from './MSME/viewgrievancereply/viewgrievancereply.component';
import { ReversebuyersellerComponent } from './IA/reversebuyerseller/reversebuyerseller.component';
import { RepositorycontentComponent } from './IA/repositorycontent/repositorycontent.component';
import { ReversebuyerrequirementComponent } from './IA/reversebuyerrequirement/reversebuyerrequirement.component';
import { InvoicedashboardmssidcComponent } from './MSSIDC/invoicedashboardmssidc/invoicedashboardmssidc.component';
import { InvoicedashboardiaComponent } from './IA/invoicedashboardia/invoicedashboardia.component';
import { GradingComponent } from './MSSIDC/grading/grading.component';
import { InvoicecalculationComponent } from './IA/invoicecalculation/invoicecalculation.component';
import { FeedbackQuestionComponent } from './MSSIDC/feedback-question/feedback-question.component';
import { CustomfeedbackComponent } from './MSSIDC/customfeedback/customfeedback.component';
import { MsmerepositorycontentComponent } from './MSME/msmerepositorycontent/msmerepositorycontent.component';
import { MsmecustomfeedbackComponent } from './MSME/msmecustomfeedback/msmecustomfeedback.component';
import { ViewinvoicedetailsComponent } from './MSSIDC/viewinvoicedetails/viewinvoicedetails.component';
import { UpdatepaymentdetailsComponent } from './MSSIDC/updatepaymentdetails/updatepaymentdetails.component';

import { ViewallonspotusersComponent } from './IA/viewallonspotusers/viewallonspotusers.component';
import { VieweventdocumentsComponent } from './IA/vieweventdocuments/vieweventdocuments.component';
import { VeiwenrolledmsmeComponent } from './IA/veiwenrolledmsme/veiwenrolledmsme.component';
import { VerifyonspotmsmeComponent } from './IA/verifyonspotmsme/verifyonspotmsme.component';
import { ViewregistermsmebyiainterestComponent } from './IA/viewregistermsmebyiainterest/viewregistermsmebyiainterest.component';
import { ViewEnrolledMSMEComponent } from './MSSIDC/view-enrolled-msme/view-enrolled-msme.component';
import { ViewattendedmsmeComponent } from './IA/viewattendedmsme/viewattendedmsme.component';
import { TimerDialogComponent } from '../../../timer-dialog/timer-dialog.component';
import { CanDeactivateGuard } from '../../../shared/services/can-deactivate.guard';
import { registrationstepGuard } from '../../../shared/services/registrationstep.guard';
import { iaregistrationstepGuard } from '../../../shared/services/iaregistrationstep.guard';
import { DownloadcertificateComponent } from './IA/downloadcertificate/downloadcertificate.component';
import { EventfeedbacklistComponent } from './IA/eventfeedbacklist/eventfeedbacklist.component';
import { UsernmanualComponent } from './usernmanual/usernmanual.component';
import { MssidcdashboardComponent } from './MSSIDC/mssidcdashboard/mssidcdashboard.component';
import { EoiinvitationComponent } from './eoiinvitation/eoiinvitation.component';
import { EoiverificationofmsmeComponent } from './eoiverificationofmsme/eoiverificationofmsme.component';
import { EoiotpverificationComponent } from './eoiotpverification/eoiotpverification.component';
import { EoiComponent } from './eoi/eoi.component';
import { EoiListComponent } from './MSSIDC/eoi-list/eoi-list.component';
import { EoiViewComponent } from './MSSIDC/eoi-view/eoi-view.component';
import { EoipdfComponent } from './eoipdf/eoipdf.component';
import { EOIExhibitionComponent } from './eoi-exhibition/eoi-exhibition.component';
import { EoiExhibitionListComponent } from './MSSIDC/eoi-exhibition-list/eoi-exhibition-list.component';
import { EoiExhibitionViewComponent } from './MSSIDC/eoi-exhibition-view/eoi-exhibition-view.component';
//import { EoiExhibitionListComponent } from './MSSIDC/eoi-exhibition-list/eoi-exhibition-list.component';
//import { EoiExhibitionViewComponent } from './MSSIDC/eoi-exhibition-view/eoi-exhibition-view.component';

//import { ConfirmationDialogComponent } from '../confirmation-dialog/confirmation-dialog.component;'

const routes: Routes = [
  //  {
  //    path: "eoiexhibition-list",
  //    component: EoiExhibitionListComponent,
  //    //canActivate: [AuthService],
  //    //data: { module: 'MSSIDC' }
  //  },

  //  {
  //    path: 'eoi-exhibition-view/:applicationId',
  //    component: EoiExhibitionViewComponent
  //},

  //{
  //  path: '',
  //  redirectTo: 'register',
  //  pathMatch: 'full'
  //},

  {
    path: '',
    component: LayoutComponent,
    children: [
      {
        path: 'msmeuserdashboard',
        component: DashboardComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: false },
      },
      {
        path: 'iauserdashboard',
        component: IadashboardComponent,
        canActivate: [AuthService],
        data: { module: 'IA', isVisible: false },
      },
      {
        path: 'msmeusersprofile',
        component: ProfileComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'eoi-list',
        component: EoiListComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'eoi-view',
        component: EoiViewComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },

      {
        path: 'eoiexhibition-list',
        component: EoiExhibitionListComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'eoi-exhibition-view/:applicationId',
        component: EoiExhibitionViewComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },

      {
        path: 'msmeuserprofile',
        component: ProfileComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: true },
      },
      {
        path: 'otheruserdetails',
        component: OtheruserdetailsComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: true },
      },
      {
        path: 'msmeotherdetails',
        component: MsmeotherdetailsComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'iaprofiledetails',
        component: ViewiadetailsComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },

      {
        path: 'vieweventlist',
        component: VieweventsComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: false },
      },
      {
        path: 'vieweventdetails',
        component: VieweventdetailsComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: false },
      },
      {
        path: 'grievanceDashboard',
        component: GrievancedashboardComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: false },
      },
      {
        path: 'viewgrievancereply',
        component: ViewgrievancereplyComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: false },
      },
      {
        path: 'enrollnewevent',
        component: EnrollneweventComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: false },
      },
      {
        path: 'feedback',
        component: MsmecustomfeedbackComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: true },
      },
      {
        path: 'downloadticket',
        component: DownloadticketComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: false },
      },
      {
        path: 'iadownloadticket',
        component: DownloadticketComponent,
        canActivate: [AuthService],
        data: {
          module: 'IA',
          isVisible: true,
        },
      },
      //{
      //  path: "feedbackform",
      //  component: FeedbackformComponent,
      //  canActivate: [AuthService],
      //  data: { module: 'MSME', isVisible: false }
      //},
      {
        path: 'submitgrievance',
        component: SubmitgrievanceComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: false },
      },

      {
        path: 'msmerepositorycontent',
        component: MsmerepositorycontentComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: false },
      },

      {
        path: 'viewflattedgala',
        component: ViewflattedgalaComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: false },
      },
      {
        path: 'changepassword',
        component: ChangepasswordComponent,
        canActivate: [AuthService],
        data: { module: 'common', isVisible: true },
      },

      {
        path: 'msmeverification',
        component: VerifymsmeComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },

      {
        //path: 'msmeverificationdetails/:msmeuserid/:action',
        path: 'msmeverificationdetails',
        component: VerifyMSMEDetailsComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'msmeverificationview/:msmeuserid/:action',
        component: VerifyMSMEViewComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'mssidcGrievanceDashboard',
        component: GrievancedashboardmssidcComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'eoi-view/:enterpriseuniqueid/:action',
        component: EoiViewComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'customiseFeefback',
        component: FeedbackQuestionComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'customiseFeefbackCreate',
        component: CustomfeedbackComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'mssidcViewandReplyGrievance',
        component: ViewandreplygrievanceComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'invoicedashboardmssidc',
        component: InvoicedashboardmssidcComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'viewinvoicedetails',
        component: ViewinvoicedetailsComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'updatepaymentdetails',
        component: UpdatepaymentdetailsComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'viewEnrolledMsMe/:eventid',
        component: ViewEnrolledMSMEComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'viewFeedbacksListmssidc/:eventid',
        component: EventfeedbacklistComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'feedbackmssidc',
        component: MsmecustomfeedbackComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'iagrievanceDashboard',
        component: GrievancedashboardiaComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'invoicedashboardia',
        component: InvoicedashboardiaComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },

      {
        path: 'invoicecalculation',
        component: InvoicecalculationComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },

      {
        path: 'iaprofile',
        component: IaprofileComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'iaproposalpage',
        component: IaproposalpageComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'view_event',
        component: VieweventComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'downloadcertificate',
        component: DownloadcertificateComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'viewEnrolledParticipants/:eventid',
        component: VeiwenrolledmsmeComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'viewAttendedParticipants/:eventid',
        component: ViewattendedmsmeComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'viewFeedbacksListia/:eventid',
        component: EventfeedbacklistComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'verifyOnSpotMSME',
        component: VerifyonspotmsmeComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'vieweventdocuments/:eventid',
        component: VieweventdocumentsComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },

      {
        path: 'event_report/:eventid',
        component: EventreportComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'eventoutputreport/:iaid/:eventid',
        component: EventreportComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },

      {
        path: 'iaquestionanswer',
        component: IaquestionanswerComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },

      {
        path: 'reversebuyerseller',
        component: ReversebuyersellerComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },

      {
        path: 'reversebuyerrequirement',
        component: ReversebuyerrequirementComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },

      {
        path: 'repositorycontetnt',
        component: RepositorycontentComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },

      {
        path: 'proposal',
        component: ProposalComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'proposal/:id', // Define the dynamic route here
        component: ProposalComponent, // Component to display the proposal details
        canActivate: [AuthService],
        data: { module: 'IA' },
      },

      {
        path: 'createnewproposal',
        component: CreatenewproposalComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },

      {
        path: 'viewallonspotregistration/:eventid',
        component: ViewallonspotregistrationComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'viewreplygrievancedetailsia',
        component: ViewandreplygrievancebyiaComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },

      {
        path: 'onspotregistration/:eventid',
        component: OnspotregistrationComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'iaeventcreate/:proposaluserid',
        component: IaeventcreateComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'proposalverification',
        component: VerifyProposalComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'grading',
        component: GradingComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'proposalverificationdetails/:proposaluserid/:action',
        component: VerifyProposalDetailsComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      //{
      //  path: 'iaprofile/:registrationId/:action',
      //  component: IaprofileComponent,
      //  canActivate: [AuthService],
      //  data: { module: 'MSSIDC' }
      //}

      {
        path: 'iaprofileonmssidc/:action',
        component: IaprofileComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'proposalverificationdetail/:proposaluserid/:action',
        component: VerifyProposalDetailsComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'workorder/:proposaluserid/:action',
        component: WorkorderComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
      {
        path: 'editevent/:eventid/:proposaluserid',
        //path: "editevent",
        component: IaeventcreateComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },

      {
        path: 'view_event',
        component: VieweventComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'dicdashboard',
        component: dicDashboardComponent,
        canActivate: [AuthService],
        data: { module: 'DIC' },
      },

      {
        path: 'fullcalender',
        component: FullCalenderComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'eventcompletion/:eventid',
        component: IaeventcompletionComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'eventmarkattendance/:eventid',
        component: IaeventmarkattendanceComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },

      {
        path: 'editonspot/:onSpotUserId',
        component: OnspotregistrationComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'ia/msmeverification',
        component: VerifymsmeComponent,
        canActivate: [AuthService],
        data: { module: 'IA', isVisible: true },
      },
      {
        path: 'allonspotuserdetails',
        component: ViewallonspotusersComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      {
        path: 'viewregistermsmebyiainterest',
        component: ViewregistermsmebyiainterestComponent,
        canActivate: [AuthService],
        data: { module: 'IA' },
      },
      //{
      //  path: "usermanual",
      //  component: UsernmanualComponent,
      //  canActivate: [AuthService],
      //  data: { module: 'IA', isVisible: true }
      //},
      //{
      //  path: "usermanual",
      //  component: UsernmanualComponent,
      //  canActivate: [AuthService],
      //  data: { module: 'MSME', isVisible: true }
      //},
      {
        path: 'usermanual',
        component: UsernmanualComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC', isVisible: true },
      },
      {
        path: 'iauserdashboard/:id',
        component: IadashboardComponent,
        canActivate: [AuthService],
        data: { module: 'IA', isVisible: true },
      },
      {
        path: 'msmeuserdashboard/:id',
        component: DashboardComponent,
        canActivate: [AuthService],
        data: { module: 'MSME', isVisible: false },
      },
      {
        path: 'mssidcdashboard/:id',
        component: MssidcdashboardComponent,
        canActivate: [AuthService],
        data: { module: 'MSSIDC' },
      },
    ],
  },
  {
    path: 'confirmation',
    component: ConfirmationDialogComponent,
    //canActivate: [AuthService],
    //data: { module: 'IA' }
  },
  {
    path: 'msmepreviewpage',
    component: MsmepreviewpageComponent,
    canActivate: [registrationstepGuard],
    //canActivate: [AuthService],
    //data: { module: 'MSME' }
  },
  {
    path: 'credentialdetails',
    component: CredentialdetailsComponent,
    canActivate: [registrationstepGuard],
    //canActivate: [AuthService],
    //data: { module: 'MSME' }
  },
  {
    path: 'contactdetails',
    component: ContactdetailsComponent,
    canActivate: [registrationstepGuard],
    //canActivate: [AuthService],
    //data: { module: 'MSME' }
  },
  {
    path: 'personaldetails',
    component: PersonaldetailsComponent,
    canActivate: [registrationstepGuard],
    //canActivate: [AuthService],
    //data: { module: 'MSME' }
  },
  {
    path: 'iaeventcreate',
    component: IaeventcreateComponent,
    canActivate: [AuthService],
    data: { module: 'IA' },
  },

  {
    path: 'iapreviewpage',
    component: IapreviewpageComponent,
    canActivate: [iaregistrationstepGuard],
    //canActivate: [AuthService],
    //data: { module: 'IA' }
  },

  {
    path: 'iasubmitnewproposal',
    component: IasubmitnewproposalComponent,
    canActivate: [AuthService],
    data: { module: 'IA' },
  },
  {
    path: 'mssidcproposalpage',
    component: MssidcproposalpageComponent,
    canActivate: [AuthService],
    data: { module: 'MSSIDC' },
  },
  {
    path: 'mssidcverifypoposal',
    component: MssidcverifyproposalComponent,
    canActivate: [AuthService],
    data: { module: 'MSSIDC' },
  },
  {
    path: 'mssidcverifypoposal',
    component: MssidcverifyproposalComponent,
    canActivate: [AuthService],
    data: { module: 'MSSIDC' },
  },
  {
    path: 'registeruseras',
    component: RegisteruserasComponent,
  },
  {
    path: 'iaregister',
    component: IAregisterComponent,
    canActivate: [iaregistrationstepGuard],
  },
  {
    path: 'msmeuserverification',
    component: MSMEUSERVERIFICATIONComponent,
    canActivate: [registrationstepGuard],
    //canDeactivate: [CanDeactivateGuard]
    //canActivate: [AuthService],
    //data: { module: 'MSME' }
  },
  {
    path: 'forgotpassword',
    component: ForgotpasswordComponent,
    canActivate: [AuthService],
    data: { module: 'common' },
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [registrationstepGuard],
    //canDeactivate: [CanDeactivateGuard]
  },
  {
    path: 'timer',
    component: TimerDialogComponent,
    //canActivate: [AuthService],
    //data: { module: 'IA' }
  },
  {
    path: 'eoi',
    component: EoiComponent,
    canActivate: [registrationstepGuard],
    //canActivate: [AuthService],
    //data: { module: 'common' }
  },
  {
    path: 'eventdetail/:eventid/:action',
    component: EventdetailComponent,
    canActivate: [AuthService],
    data: { module: 'IA' },
  },

  {
    path: 'msmeverification',
    component: VerifymsmeComponent,
    canActivate: [AuthService],
    data: { module: 'IA' },
  },
  {
    path: 'EOI',
    component: EoiinvitationComponent,
    //canActivate: [registrationstepGuard],
    //canActivate: [AuthService],
    //data: { module: 'common' }
  },

  {
    path: 'eoiverification',
    component: EoiverificationofmsmeComponent,
    canActivate: [registrationstepGuard],
    //canActivate: [AuthService],
    //data: { module: 'common' }
  },
  {
    path: 'eoipdf',
    component: EoipdfComponent,
    canActivate: [registrationstepGuard],
    //canActivate: [AuthService],
    //data: { module: 'common' }
  },
  {
    path: 'eoiotpverification',
    component: EoiotpverificationComponent,
    canActivate: [registrationstepGuard],
    //canActivate: [AuthService],
    //data: { module: 'common' }
  },
  {
    path: 'eoiexhibition',
    component: EOIExhibitionComponent,
    // canActivate: [registrationstepGuard],
    //canActivate: [AuthService],
    //data: { module: 'common' }
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class WebsiteRoutingModule {}
